import Vue from 'vue'

export async function getUser(id) {
    const response = await Vue.prototype.$httpDist.get('/user/' + id);
    return response
}